import React from "react";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import { AUTH_COLORS, AUTH_FONT, AUTH_LINKS } from "../../config/authConstants";
import arrowUpRight from "../../Assests/Images/auth/arrow-up-right.svg";

function AuthFooter() {
  return (
    <Box
      component="footer"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 2,
        px: { xs: 2, sm: 3 },
        pt: "17px",
        pb: "16px",
        bgcolor: AUTH_COLORS.surface,
        borderTop: "1px solid " + AUTH_COLORS.borderSecondary,
        width: "100%",
        boxSizing: "border-box",
        zIndex: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          gap: { xs: 1.5, sm: 3 },
        }}
      >
        <Typography
          component="span"
          sx={{
            fontFamily: AUTH_FONT,
            fontSize: { xs: 13, sm: 15 },
            fontWeight: 400,
            lineHeight: 1.2,
            color: AUTH_COLORS.textStrong,
          }}
        >
          {AUTH_LINKS.copyright}
        </Typography>

        <Box
          component="nav"
          aria-label="Legal"
          sx={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: { xs: 1.5, sm: 2 },
          }}
        >
          <Link
            href={AUTH_LINKS.terms}
            underline="hover"
            sx={{
              fontFamily: AUTH_FONT,
              fontSize: { xs: 13, sm: 15 },
              fontWeight: 400,
              color: AUTH_COLORS.textStrong,
            }}
          >
            {AUTH_LINKS.termsLabel}
          </Link>
          <Link
            href={AUTH_LINKS.privacy}
            underline="hover"
            sx={{
              fontFamily: AUTH_FONT,
              fontSize: { xs: 13, sm: 15 },
              fontWeight: 400,
              color: AUTH_COLORS.textStrong,
            }}
          >
            {AUTH_LINKS.privacyLabel}
          </Link>
          <Link
            href={AUTH_LINKS.cookies}
            underline="hover"
            sx={{
              fontFamily: AUTH_FONT,
              fontSize: { xs: 13, sm: 15 },
              fontWeight: 400,
              color: AUTH_COLORS.textStrong,
            }}
          >
            {AUTH_LINKS.cookiesLabel}
          </Link>
        </Box>
      </Box>

      <Chip
        component="a"
        href={AUTH_LINKS.worklife}
        target="_blank"
        rel="noopener noreferrer"
        clickable
        label={
          <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1 }}>
            <Typography
              component="span"
              sx={{
                fontFamily: AUTH_FONT,
                fontSize: 15,
                fontWeight: 400,
                lineHeight: 1.2,
                color: AUTH_COLORS.textStrong,
              }}
            >
              {AUTH_LINKS.worklifeLabel}
            </Typography>
            <Box
              component="img"
              src={arrowUpRight}
              alt=""
              sx={{ width: 16, height: 16, display: "block" }}
            />
          </Box>
        }
        sx={{
          height: "auto",
          borderRadius: "46px",
          bgcolor: AUTH_COLORS.surface,
          border: "1px solid " + AUTH_COLORS.borderSecondary,
          px: 1,
          py: 0.5,
          "& .MuiChip-label": {
            px: 1,
            py: 0.5,
          },
          "&:hover": {
            bgcolor: AUTH_COLORS.bgSoft,
            borderColor: AUTH_COLORS.primary,
          },
        }}
      />
    </Box>
  );
}

export default AuthFooter;
